/**
 * Singleton de config do shell. Lê env vars do Vite (build-time) e expõe
 * defaults sentinela pra debugging quando var não foi injetada no build
 * (alinhado com App.tsx original que já mostra sentinela no footer).
 *
 * CLAUDE.md: "hostnames via env, nunca hardcode usehook.net".
 */
export interface ShellConfig {
  apiHost: string;
  cookieDomain: string;
  r2Host: string;
}

function readEnv(key: keyof ImportMetaEnv, label: string): string {
  const v = import.meta.env[key];
  return v && v.length > 0 ? v : `(${label} not set)`;
}

export const config: ShellConfig = {
  apiHost: readEnv('VITE_API_HOST', 'VITE_API_HOST'),
  cookieDomain: readEnv('VITE_COOKIE_DOMAIN', 'VITE_COOKIE_DOMAIN'),
  r2Host: readEnv('VITE_R2_HOST', 'VITE_R2_HOST'),
};
